<template>
  <div class="landing">
    <div class="overlay" />
    <div class="modal">
      <img src="@/assets/img/mob-top.svg" alt="top" class="modal__top">
      <div class="modal-content">
        <img src="@/assets/img/logo.svg" alt="logo" class="modal__logo">
        <img src="@/assets/img/mob-form-top.png" alt="top" class="modal__form-top">
        <div class="modal__title">Регистрация</div>
        <form
          action="#"
          id="registrationForm"
          class="form"
          :class="{'form_disabled': isRequestSending}"
          @submit.prevent="submitForm"
        >
          <div class="form-row">
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Номер телефона или E-mail"
              v-model="contact"
              required
            />
          </div>
          <div class="form-row">
            <input
              type="password"
              id="password"
              placeholder="Введите пароль"
              v-model="password"
              required
            />
          </div>
          <div class="form-row">
            <select
              id="country"
              v-model="country"
            >
              <option value="RU" selected>Россия</option>
              <option value="UA">Украина</option>
            </select>
          </div>
          <div class="form-row">
            <select
              id="currency"
              v-model="currency"
            >
              <option value="RUB" selected>RUB</option>
              <option value="USD">USD</option>
            </select>
          </div>
          <input
            type="submit"
            class="btn-register"
            id="register"
            value="Регистрация"
          />
          <div class="checkbox-group">
            <input
              type="checkbox"
              id="checkbox"
              name="checkbox"
              v-model="checkbox"
              required
            />
            <label for="checkbox">
              Я согласен с <a href="#">Условиями и приложениями</a> и
              подтверждаю, что мне исполнилось 18 лет
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification'
import axios from 'axios'

const APIs = {
  volna: 'volna.casino',
  drip: 'drip.casino',
  starda: 'starda.casino',
  legzo: 'legzo.casino',
  izzi: 'izzicasino.com',
  jet: 'jet.casino',
  sol: 'sol.casino',
  fresh: 'fresh.casino',
  rox: 'roxcasino.com',
  monro: 'monro.casino',
  '1go': '1gocasino.com',
  lex: 'lex.casino',
  gizbo: 'gizbo.casino',
  irwin: 'irwin.casino',
  flagman: 'flagman.casino',
  martin: 'martin.casino',
  beef: 'beef.casino'
}

const REDIRECT = {
  volna: 'https://wlilies.lakevln.com/nice',
  drip: 'https://shine.beautydrp.com/eoja',
  starda: 'https://marathon.runstd.com/just',
  legzo: 'https://trust.kudoslzo.com/undsg',
  izzi: 'https://boxing.championizzi.com/lknmd',
  jet: 'https://green.grapefruitjet.com/jastyg',
  sol: 'https://reflection.mirrorsol.com/imhgf',
  fresh: 'https://large.grapefsh.com/kwnfgsw',
  rox: 'https://country.rocknrox.com/jsdfyedmd/',
  monro: 'https://cinema.tographymnro.com/flicks',
  '1go': 'https://casino.ship1go.com/pulsar',
  lex: 'https://wager.winningslex.com/roulette',
  gizbo: 'https://coin.cashgzb.com/sweet',
  irwin: 'https://finite.recursionirwin.com/thread',
  flagman: 'https://special.headflgm.com/gold/',
  martin: 'https://hunting.falconmrtn.com/voice',
  beef: 'https://walk.boroughbee.com/road'
}

export default {
  name: 'landing-page',
  data () {
    return {
      contact: '',
      password: '',
      country: 'RU',
      currency: 'RUB',
      checkbox: false,
      isRequestSending: false,
      apiUrl: 'irwin.casino',
      redirect: 'https://finite.recursionirwin.com/thread',
      code: ''
    }
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    const brand = urlParams.has('brand') ? urlParams.get('brand') : 'irwin'
    this.apiUrl = APIs[brand]
    this.redirect = REDIRECT[brand]
    this.code = urlParams.has('code') ? urlParams.get('code') : ''
    window.history.replaceState({}, null, '/')
  },
  methods: {
    submitForm () {
      if (this.isRequestSending) {
        return
      }

      const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      const PHONE_REGEXP = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/

      const contact = this.contact.trim().replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '')
      let phoneContact = ''
      let emailContact = ''
      let contactType = 'phone'

      if (contact.includes('@')) {
        contactType = 'email'

        emailContact = EMAIL_REGEXP.test(contact) ? contact : ''
      } else {
        contactType = 'phone'

        phoneContact = PHONE_REGEXP.test(contact) ? contact : ''

        if (phoneContact.startsWith('8')) {
          phoneContact = contact.replace('8', '+7')
        }
      }

      const data = {
        user: {
          country: this.country,
          currency: this.currency,

          bonus_code: this.code,
          captcha: '',
          parent_refcode: '',
          profile_attributes: {
            age_acceptance: true,
            terms_acceptance: true,
            game_currency: this.currency,
            receive_newsletters: false,
            receive_promos: false,
            last_name: '',
            first_name: '',
            receive_sms_promos: false,
            nickname: '',
            currency: this.currency,
            language: 'ru',
            country: this.country
          },
          password: this.password,
          password_confirmation: this.password
        },
        lang: 'ru'
      }

      if (contactType === 'email' && emailContact) {
        data.user.email = emailContact
      } else if (contactType === 'phone' && phoneContact) {
        data.user.phone = {
          country: this.country,
          number: phoneContact
        }
      } else {
        useToast().error('Неверный email или номер телефона')

        return
      }

      data.apiUrl = this.apiUrl

      this.isRequestSending = true
      this.fetchData(data)
    },
    fetchData (data) {
      axios.post('/script.php', data, {
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      })
        .then((response) => {
          this.isRequestSending = false

          if (response.status === 200 || response.statusText === 'OK') {
            if (response.data) {
              const { token } = response.data
              const newUrl = `${this.redirect}/api/users/token?token=${token}`

              if (token && token.length) {
                useToast().success('Успешная регистрация! Перенаправление...')
                document.location.href = newUrl

                return
              }
            }

            useToast().error('Ошибка при регистрации')

            return
          }

          console.log('error', response)
          useToast().error('Ошибка при отправке запроса')
        })
        .catch((error) => {
          this.isRequestSending = false

          console.log('request error', error)
          useToast().error('Ошибка при отправке запроса')
        })
    }
  }
}
</script>

<style src="./style.scss" lang="scss"></style>
